import Crud from '../views/Checklist/Crud'
import View from '../views/Checklist/View'

let routes = {
    path: '/checklists',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [

        {
            path: '/checklists/view/:id?',
            name: 'ViewChecklist',
            component: View,
            meta: {
                perfil_id: ['1', '2', '6', '7'] // Perfis 1, 2 e 6 podem executar
            }
        },
        {
            path: '/checklists',
            name: 'list-checklists',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Checklists',
                breadcrumb: [
                    {
                        text: 'Checklists',
                        active: true,
                    },
                ],
                perfil_id: ['1', '2', '6', '7'] // Perfis 1, 2 e 6 podem acessar
            },
        },
    ]
};


export default routes
